import React from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
// Ust
import { useInvAF } from "../../../../St/Reviews/UseStyle";
// csG
import { stElemnt } from "../../../../St/Reviews/cStyle";

import { colors, Container, makeStyles, Typography } from "@material-ui/core";
import { useBody } from "../../invCompany/style";
import { txtA, txtE } from "../../../../Label/Lbl";
import InvTotal from "../../AFReadyDisigen/A4/InvTotal";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import { Rept } from "../../../../Context/InshData";
const BodyInv = (props) => {
  const cls = useRptAF();
  const { onUnmountComplete, data, isFullPage, isLast, found, inv, sta } = props;


  const clas = useInvAF();
  const calssBody = useBody();
  //   const islast=(data?.length )
  const cellSS = {

    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "0.7rem",
    width: "400px",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };
  const cellS = {

    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "0.7rem",
    width: "300px",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };

  const cellSDel = {
    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    border: "solid 0.1px",
    fontSize: "0.7rem",
    maxWidth: "300px",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };

  const locInv = JSON.parse(localStorage.getItem("datainv")) || {};
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

  var columns = [
    { title: "No \n م", field: "no" },
    { title: "Barcode \n الباركود", field: "barcode" },
    { title: "Item Name \n اسم الصنف", field: "symbol", cellStyle: premiApp.billTemplate === 1 ? cellSDel : cellS },
    {
      title: "Price \n سعر الوحدة",
      field: "new_exchange_price",

    },
    { title: "Qoantity \n الكمية ", field: "val1" },
    // { title: txtA.taxableAmount, field: "totBill" },
    { title: "Discount \n الخصم", field: "discount" },
    { title: "BeforeVat" + "\n" + "الخاضع للضريبة", field: "totBill" },
    // { title: txtA.taxRate, field: "taxperc" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];

  var columns2 = [
    { title: "Description \n الوصف", field: "notes_details", cellStyle: cellSS },
    { title: "Unit \n الوحدة", field: "unit_name", },
    {
      title: "Price \n سعر الوحدة",
      field: "new_exchange_price",
    },
    { title: "Qoantity \n الكمية ", field: "val1" },
    { title: "Discount \n الخصم", field: "discount" },
    { title: "BeforeVat" + "\n" + "الخاضع للضريبة", field: "totBill" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];
  var columns3 = [
    { title: "No \n م", field: "no" },
    { title: "Description \n الوصف", field: "notes_detailsItems", cellStyle: cellSS },
    {
      title: "Price \n سعر الوحدة",
      field: "new_exchange_price",

    },
    { title: "Qoantity \n الكمية ", field: "val1" },
    { title: "BeforeVat" + "\n" + "الخاضع للضريبة", field: "totBill" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];

  const cellSD4 = {

    // padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    border: "solid 0.1px",
    fontSize: "0.75rem",
    width: "300px",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    direction: "rtl",
    textAlign: "right",
    paddingRight:"5px",
    paddingTop:"0px",
    paddingBottom:"0px"
  };
  var columns4 = [
    { title: "No \n م", field: "barcode" },
    { title: "Description \n الوصف", field: "notesall", cellStyle: cellSD4 },
    {
      title: "Price \n سعر الوحدة",
      field: "new_exchange_price",
    },
    { title: "Qoantity \n الكمية ", field: "val1" },
    // { title: "Discount \n الخصم", field: "discount" },
    { title: "BeforeVat" + "\n" + "الخاضع للضريبة", field: "totBill" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];

  const mergColumn = (symbol,nameEN) => {
    if (nameEN !=null && nameEN !=""){
      return `${symbol} \n ${nameEN}`
    }else{
      return `${symbol}`
    }
};
  const data2 = data.map((row, i) => {
    return {
      ...row,
      id: i + 1,
      notesall:mergColumn(row.symbol,row.notes_details),
      totBill: new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(row.totBill),
      new_exchange_price: row.exchange_price.toFixed(locInv?.NRound??4),
      amountAfterDisc: new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(row.amountAfterDisc),
      tot_net_curr: new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(row?.tot_net_curr),
      discount: new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(row?.discount),
    };
  });

  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container //className={cls.rootBdyup}
        style={{
          paddingTop: "0.5rem", direction: "rtl", border: "dotted 1px #393939",
        }}>
        <Grid
          item
          xs={12}
          style={{

          }}
        >
          <MaterialTable
            style={{ boxShadow: "none" }}
            // style={{direction:'ltr'}}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",
              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
              },
            }}
            localization={{ body: { emptyDataSourceMessage: <h1></h1> } }}
            columns={premiApp.billTemplate === 12 ? (columns2.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))) : premiApp.billTemplate === 15 ? (columns3.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))) : premiApp.billTemplate === 17 ? (columns4.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))) :
              (columns.map(column => ({
                ...column,
                title: column.title.split("\n").map((line, index) => (
                  <div key={index}>{line}</div>
                )),

              })))}
            data={data2}
          />
          {isLast && <InvTotal inv={inv} sta={sta} />}
        </Grid>

      </Grid>

    </Grid>
  );
};

export default BodyInv;
